<template>
	<div class="add-form">
		<Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
			<div class="tag-title">系统配置</div>
			<FormItem label="策划支持" prop="show_support">
				<RadioGroup v-model="form.show_support">
					<Radio label="1">开启</Radio>
					<Radio label="0">关闭</Radio>
				</RadioGroup>
			</FormItem>
		</Form>
		<Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
		<Button ghost type="primary" icon="ios-arrow-back" @click="$router.go(-1)">返回</Button>
	</div>
</template>

<script>
	import { apiGetSystem, apiSetSystem } from '@/api/organization'

	export default {
		name: 'add-form',
		data() {
			return {
				query: {},
				search: {},
				diyDom: {},
				// 表单数据
				form: {
					show_support: '1',
				},
				diyData: {
					rules: {
						show_support: [
							{
								required: true,
								message: '请选择是否开启策划支持',
								trigger: 'blur',
							},
						],
					},
				},
				apiData: {},
			}
		},
		computed: {
			import_cert() {
				return process.env.VUE_APP_API_URL + '/upload/file'
			},
			headers() {
				return {
					authorization: localStorage.getItem('token'),
				}
			},
		},
		methods: {
			// 获取配置
			getSettings() {
				this.$store.commit('setSpinShow', true)
				apiGetSystem(this.query.id, 'system')
					.then(res => {
						const { show_support } = res
						this.form.show_support = show_support + ''
					})
					.finally(() => this.$store.commit('setSpinShow', false))
			},
			submit() {
				this.$refs['addForm'].validate(valid => {
					if (valid) {
						apiSetSystem(this.query.id, 'system', {
							system: this.form,
						}).then(() => {
							this.$Message.success('保存成功')
							this.getSettings()
						})
					}
				})
			},
		},

		mounted() {
			this.query = this.$route.query
			this.getSettings()
		},
	}
</script>

<style scoped lang="less">
	.add-form {
		border: 1px solid #ededed;
		margin: 0 20px;
		padding: 26px 20px;

		.title {
			font-size: 14px;
			font-weight: bold;
			color: #333333;
			line-height: 19px;
			margin-bottom: 10px;
		}
	}
</style>
